import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../../AgentForm.module.scss';

interface IAnimatedLoadingProps {
  color?: string;
}
const AnimatedLoading = (props: IAnimatedLoadingProps) => {
  const { color } = props;
  return (
    <div className="flex pl-5">
      <div>
        <Typography variant="h5" color="var(--navi-color-gray-c3)">
          {`Verifying `}
        </Typography>
      </div>
      <div className={styles.wave} style={{ '--dot-color': color } as React.CSSProperties}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </div>
  );
};

export default AnimatedLoading;
